import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Constant from '../Components/Utils/Constant';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../Components/Sidebar';
import { useSelector } from 'react-redux';


export default function ModalmanagerEdit() {
    const navigate = useNavigate();
    const { modelmanager_id } = useParams();
    const modelmanagerId = modelmanager_id;
    const [isVisible, setIsVisible] = useState(true);
    const [email, setEmail] = useState("");
    const [name, setName] = useState('');
    const [phone, setPhone] = useState("");
    const [newPassword, setPassword] = useState('');
    const [createdby, setCreatedby] = useState('');
    const [modelmanager, setModelmanager] = useState([]);
    const [totalCount, setTotalCount] = useState(null);
    const [totalPages, setTotalPages] = useState(1);
    const [modelmanagername, setModelmanagername] = useState("");
    const [SelectedModelmanager, setSelectedModelmanager] = useState({})
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [isPhoneValid, setIsPhoneValid] = useState(true);



    useEffect(() => {
        const storedName = localStorage.getItem("name");

        if (storedName) {
            setModelmanagername(storedName);
            setCreatedby(storedName);
        } else {
            setModelmanagername("Unauthorized");
            setCreatedby("Unauthorized");
        }
    }, []);

    const handleClose = () => {
        setIsVisible(false);
    };

    useEffect(() => {
        if (modelmanager.length > 0) {
            getModelmanagerById(modelmanager_id)
        }
    }, [modelmanager])

    useEffect(() => {

        setValue()
    }, [SelectedModelmanager])

    const setValue = () => {
        setName(SelectedModelmanager.name)
        setEmail(SelectedModelmanager.email)
        setPhone(SelectedModelmanager.phone)
        setPassword(SelectedModelmanager.newPassword)
    }


    const getModelmanagerById = (id) => {
        setSelectedModelmanager(
            modelmanager.find((item) => {
                return item._id == id
            })
        )

    }

    // get api  
    useEffect(() => {
        const fetchModelmanager = async () => {
            try {
                const response = await fetch(`${Constant.BASE_URL}/modelmanager/get`);
                const data = await response.json();
                // setUser(data.admins);
                if (data && data.modelmanager) {
                    setModelmanager(data.modelmanager);
                    if (data.success) {
                        setTotalCount(data.totalCount);
                        setTotalPages(data.totalPages);
                    }
                }
                // setLoading(false);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchModelmanager();
    }, []);

    // validationss 
    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    const validatePhone = (phone) => {
        const phoneRegex = /^\d{10}$/;
        return phoneRegex.test(phone);
    };


    const handleUpdate = async (e) => {
        e.preventDefault();
        const isEmailValid = validateEmail(email);
        const isPhoneValid = validatePhone(phone);
        setIsEmailValid(isEmailValid);
        setIsPhoneValid(isPhoneValid);
        if (isEmailValid && isPhoneValid) {
            try {
                const modelmanagerData = {
                    email,
                    name,
                    phone,
                    newPassword,
                    createdby,
                };
                const response = await axios.put(`${Constant.BASE_URL}/modelmanager/update`, modelmanagerData);
                if (response.status === 200) {
                    // navigate to the main page
                    navigate("/modelsManager");

                    handleClose();
                    setEmail('');
                    setName('');
                    setPassword('');
                    setPhone('');

                    // close the update form 
                    handleClose();

                    console.log("update sucessfully");
                } else {
                    console.log("Update failed:", response.status);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };
    return (
        <Sidebar>
            <>
                <div className="flex justify-center ">
                    {/* Edit form  */}
                    {modelmanager.map((modelmanager) => (
                        <div key={modelmanager._id}>
                            <div className=" flex justify-center ">
                                <div className="absolute lg:top-[170px] xl:top-[200px] 2xl:top-[550px]  flex items-center justify-center z-10">
                                    <div className="bg-white p-4 rounded-md py-3 px-1 lg:py-3 xl:py-3 2xl:p-4  w-fit">
                                        <div className="lg:w-[300px] xl:w-[300px] 2xl:w-[400px] items-center justify-center">
                                            <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl ">
                                                Edit  Modal Manager
                                            </div>
                                            <hr className="mt-1 " />

                                            <form onSubmit={handleUpdate}>
                                                <div className="flex flex-col justify-center items-center ">
                                                    <div className='lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]'>
                                                        <div className="flex py-3 justify-end items-center">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                Name:<span className="text-red-500 ml-1">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="yourInput"
                                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                style={{ width: '163px', textAlign: 'center' }}
                                                                placeholder="Text"
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="flex py-3 justify-end items-center">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                Phone :<span className="text-red-500 ml-1">*</span>
                                                            </label>
                                                            <div className="flex flex-col">
                                                                <input
                                                                    type="tel"
                                                                    id="yourInput"
                                                                    className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                    style={{ width: "163px", textAlign: "center" }}
                                                                    placeholder="number"
                                                                    value={phone}
                                                                    onChange={(e) => setPhone(e.target.value)}
                                                                    required
                                                                />
                                                                {!isPhoneValid && (
                                                                    <p className="text-red-500">
                                                                        Invalid phone format (10 digits)
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="flex py-3 justify-end items-center">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                Email :<span className="text-red-500 ml-1">*</span>
                                                            </label>
                                                            <div className="flex flex-col">
                                                                <input
                                                                    type="text"
                                                                    id="yourInput"
                                                                    className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                    style={{ width: "163px", textAlign: "center" }}
                                                                    placeholder="email"
                                                                    value={email}
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                    required
                                                                />
                                                                {!isEmailValid && (
                                                                    <p className="text-red-500 ml-1">
                                                                        Invalid email format
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="flex py-3 justify-end items-center">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                Password :<span className="text-red-500 ml-1"></span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="yourInput"
                                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                style={{ width: '163px', textAlign: 'center' }}
                                                                placeholder="..............."
                                                                value={newPassword}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                            />
                                                        </div>

                                                        <div className="flex py-3 justify-end items-center">
                                                            <label
                                                                htmlFor="yourInput"
                                                                className="flex items-end px-3"
                                                            >
                                                                Created By :<span className="text-red-500 ml-1">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                id="yourInput"
                                                                className="border-b border-gray-500 outline-none flex items-start mb-2"
                                                                style={{ width: '163px', textAlign: 'center' }}
                                                                placeholder="Super Admin (Auto)"
                                                                value={modelmanagername}
                                                                onChange={(e) => setCreatedby(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                                                        <Link to="/modelsManager">
                                                            <button
                                                                type="button"
                                                                onClick={handleClose}
                                                                className=" bg-white px-3 py-1 flex-shrink-0 shadow-md"
                                                                style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </Link>
                                                        <button
                                                            type="submit"
                                                            className="px-3 py-1 flex-shrink-0 "
                                                            style={{
                                                                background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                                                            }}
                                                        >
                                                            Update
                                                        </button>

                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div >
                        </div>
                    ))}
                </div >
            </>
        </Sidebar>
    )
}
